// Fluxo de caixa — "quanto entrou, quanto saiu, sobrou ou faltou?"
// Sem divisão pro-cliente/minha-cópia (controle interno). docs/...spec §6.

export interface FluxoCaixaInputs {
  /** Quanto tinha no começo do período (pode ser negativo). */
  saldoInicial: number
  /** Soma das entradas (lista na UI). */
  totalEntradas: number
  /** Soma das saídas (lista na UI). */
  totalSaidas: number
}

export interface FluxoCaixaResultado {
  saldoInicial: number
  totalEntradas: number
  totalSaidas: number
  /** saldoInicial + entradas − saídas. */
  saldoFinal: number
  /** Resultado do período, sem o saldo inicial (entradas − saídas). */
  resultado: number
  status: 'positivo' | 'negativo'
}

const round2 = (n: number) => Number(n.toFixed(2))

export function calcularFluxoCaixa(inputs: FluxoCaixaInputs): FluxoCaixaResultado {
  const saldoInicial = inputs.saldoInicial || 0
  const totalEntradas = inputs.totalEntradas || 0
  const totalSaidas = inputs.totalSaidas || 0

  const saldoFinal = saldoInicial + totalEntradas - totalSaidas
  const resultado = totalEntradas - totalSaidas

  return {
    saldoInicial: round2(saldoInicial),
    totalEntradas: round2(totalEntradas),
    totalSaidas: round2(totalSaidas),
    saldoFinal: round2(saldoFinal),
    resultado: round2(resultado),
    status: saldoFinal >= 0 ? 'positivo' : 'negativo',
  }
}
